import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { DATE_FORMATS } from "../../../../../../constants";
import { PasteExerciseComponent } from "../../../../../../parts/PasteExerciseComponent";
import SvgIcon from "../../../../../../parts/SvgIcon";
import ToolTip from "../../../../../../parts/tooltip-portal";
import { getHighestOrder } from "../../../../../../utils/prefix-calculator";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

const Footer = ({
  date,
  editDayMode,
  handleRemoveMultiple,
  resetExercises,
  saveEditedExercise,
  hasExercise = false,
  athleteId,
  toggleEditDayMode,
  exercisesInClipboard,
  athlete,
  exercises,
  sections = [],
}) => {
  const { t } = useTranslation(["athlete-portal", "common"]);
  // Sections share the exercise order space, so the "next order" for a new
  // section/import/paste must account for both (otherwise they collide with or
  // sit above existing sections). -1 when empty → first section lands at -0.5.
  const highestOrder = getHighestOrder(exercises, sections);

  return (
    <footer>
      {editDayMode ? (
        <div className="button-group">
          <button
            data-button-type="secondary"
            className="text-(--danger)!"
            onClick={() => resetExercises()}
          >
            {t("athlete-portal:exerciseEditor.discard")}
          </button>
          <button
            data-button-type="primary"
            onClick={() => saveEditedExercise(athleteId)}
          >
            {t("common:save")}
          </button>
        </div>
      ) : (
        <>
          <a
            href={`/actions/refresh?modal[type]=calendar-add-exercise&day=${date.format(
              DATE_DAY_FORMAT
            )}`}
            data-button-type="text"
            role="button"
          >
            <SvgIcon
              src="/img/new-icons/add-gradient-icon.svg"
              className="h-5 w-5"
              noFilterOnLight={true}
            />
            <span className="font-semibold">
              {t("athlete-portal:exerciseEditor.addExercise")}
            </span>
          </a>
          {hasExercise ? (
            <div className="flex items-center gap-1">
              <ToolTip
                id="add-section"
                body={t("athlete-portal:exerciseEditor.addSection")}
              >
                <a
                  href="#_"
                  onClick={(e) => {
                    e.preventDefault();
                    submit(
                      `/actions/exercise-section/create?proxyAthlete=${athleteId}&reqSource=calendar`,
                      {
                        method: "POST",
                        body: {
                          name: t("athlete-portal:exerciseEditor.newSection"),
                          order: highestOrder + 0.5,
                          utcDate: Number(date.format("YYYYMMDD")),
                          date: date.toJSON(),
                        },
                      }
                    );
                  }}
                  data-button-type="secondary"
                  role="button"
                >
                  <SvgIcon src="/img/new-icons/workout-sections-icon.svg" />
                </a>
              </ToolTip>
              <ToolTip
                id="import-workout"
                body={t("athlete-portal:exerciseEditor.importWorkout")}
              >
                <a
                  href={`/actions/refresh?modal[type]=import-workout&day=${date.format(
                    DATE_DAY_FORMAT
                  )}&exercisesLength=${
                    exercises?.length || 0
                  }&highestOrder=${highestOrder}`}
                  data-button-type="secondary"
                  role="button"
                >
                  <SvgIcon src="/img/new-icons/import.svg" />
                </a>
              </ToolTip>
              <PasteExerciseComponent
                athlete={athlete}
                date={date.format(DATE_DAY_FORMAT)}
                query={exercisesInClipboard}
                haveExercises={true}
                exercisesLength={exercises?.length}
                highestOrder={highestOrder}
              />
              <ToolTip
                id="edit-exercises"
                body={t("athlete-portal:exerciseEditor.quickEdit")}
              >
                <a
                  onClick={() => {
                    toggleEditDayMode();
                  }}
                  href="#_"
                  data-button-type="secondary"
                  role="button"
                >
                  <SvgIcon src="/img/new-icons/edit-pencil.svg" />
                </a>
              </ToolTip>
              <ToolTip
                id="duplicate-exercises"
                body={t("athlete-portal:exerciseEditor.duplicateWorkout")}
              >
                <a
                  href={`/actions/refresh?modal[type]=calendar-duplicate-workout&day=${date.format(
                    DATE_DAY_FORMAT
                  )}`}
                  data-button-type="secondary"
                  role="button"
                >
                  <SvgIcon src="/img/new-icons/duplicate.svg" />
                </a>
              </ToolTip>
              <ToolTip
                id="delete-exercises"
                body={t("athlete-portal:exerciseEditor.deleteAllExercises")}
              >
                <a
                  href="#"
                  onClick={(e) => handleRemoveMultiple(e, date)}
                  data-button-type="secondary"
                  role="button"
                >
                  <img src="/img/new-icons/red-trash.svg" alt="remove" />
                </a>
              </ToolTip>
            </div>
          ) : null}
        </>
      )}
    </footer>
  );
};

export default Footer;
